export const center_app_version = {"commit_sha": "d46da07e"}
